document.addEventListener("DOMContentLoaded", () => {
  const hide_newsletter = document.querySelector(".hide_newsletter");

  if (hide_newsletter) {
    // Wenn ja, führe den ursprünglichen Code aus
    document.querySelectorAll(".shopify-section-group-group-footer")
      .forEach(el => {
        if (!el.classList.contains("section-footer")) {
          el.style.display = "none";
        }
      });
  }
});

document.addEventListener("DOMContentLoaded", () => {

  if (window.innerWidth > 767) return;

  document.querySelectorAll('.collapsible-container .collapsible-text').forEach(el => {
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    const maxLines = 5;
    const maxHeight = lineHeight * maxLines;

    const fullHTML = el.innerHTML.trim();
    el.style.maxHeight = 'none';
    el.style.overflow = 'visible';

    if (el.scrollHeight <= maxHeight) return;

    const tempEl = document.createElement('div');
    tempEl.style.visibility = 'hidden';
    tempEl.style.position = 'absolute';
    tempEl.style.width = el.clientWidth + 'px';
    tempEl.innerHTML = fullHTML;
    document.body.appendChild(tempEl);

    let words = tempEl.textContent.split(' ');
    let truncated = '';
    let finalHTML = '';
    tempEl.innerHTML = '';

    for (let i = 0; i < words.length; i++) {
      tempEl.textContent = truncated + words[i] + ' ';
      if (tempEl.scrollHeight > maxHeight) {
        finalHTML = truncated.trim() + '... <span class="read-more">mehr</span>';
        break;
      }
      truncated += words[i] + ' ';
    }
    tempEl.remove();

    el.innerHTML = finalHTML;
    el.classList.add('truncated'); // padding-right wird aktiv

    const readMore = el.querySelector('.read-more');
    if (readMore) {
      readMore.addEventListener('click', () => {
        el.style.maxHeight = 'none';
        el.style.overflow = 'visible';
        el.classList.remove('truncated'); // padding weg
        el.innerHTML = fullHTML; // Text wiederherstellen
      });
    }
  });
});